module.exports = __webpack_public_path__ + "static/luminous_2-06808cbd773fbbd1090f4cc0c158e742.jpg";